var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5758 4.43466C15.2307 4.08957 14.6733 4.08957 14.3282 4.43466L10.0013 8.7527L5.67442 4.42581C5.32933 4.08072 4.77187 4.08072 4.42679 4.42581C4.0817 4.7709 4.0817 5.32835 4.42679 5.67344L8.75367 10.0003L4.42679 14.3272C4.0817 14.6723 4.0817 15.2298 4.42679 15.5748C4.77187 15.9199 5.32933 15.9199 5.67442 15.5748L10.0013 11.248L14.3282 15.5748C14.6733 15.9199 15.2307 15.9199 15.5758 15.5748C15.9209 15.2298 15.9209 14.6723 15.5758 14.3272L11.2489 10.0003L15.5758 5.67344C15.9121 5.3372 15.9121 4.7709 15.5758 4.43466Z",
    fill: "#242626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseX);
export default __webpack_public_path__ + "static/media/icon-close-x.b27929cb08d3bf2bcadf73fdc3b146d8.svg";
export { ForwardRef as ReactComponent };